// Imágenes reales para el carrusel de la Iglesia Cristiana Cuadrangular
import Img1 from './Img-1.jpg';
import Img2 from './Img-2.jpg';
import Img3 from './Img-3.jpg';
import Img4 from './Img-4.jpg';
import Img5 from './Img-5.jpg';
import Img6 from './Img-6.jpg';

export const carouselImages = [
  {
    src: Img1,
    alt: 'Iglesia Cristiana Cuadrangular - Vista exterior'
  },
  {
    src: Img2,
    alt: 'Congregación en servicio dominical'
  },
  {
    src: Img3,
    alt: 'Momento de adoración y alabanza'
  },
  {
    src: Img4,
    alt: 'Interior del templo durante el culto'
  },
  {
    src: Img5,
    alt: 'Actividades comunitarias de la iglesia'
  },
  {
    src: Img6,
    alt: 'Eventos especiales y celebraciones'
  }
];